import * as actionTypes from "../../actionTypes";
import * as api from "../../../api/index";
import { toast } from "react-toastify";

export const GetDOTLicenseBatchesCERT = (page, limit, query, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getDOTLicenseBatchesCERT(page, limit, query);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_DOT_LICENSE_BATCHES_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    if (setLoading) setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    if (setLoading) setLoading(false);
  }
};

export const CreateDOTLicenseBatchCERT = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  let res, statusCode;
  try {
    const { data, status } = await api.createDOTLicenseBatchCERT(formData);
    res = data;
    statusCode = status;
    if (status === 201) {
      toast.success(data.message);
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
  }
  return { res, statusCode };
};

export const GetDOTLicenseBatchDetailCERT = (id, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  if (setLoading) setLoading(true);
  try {
    const { data, status } = await api.getDOTLicenseBatchDetailCERT(id);
    if (status === 200) {
      dispatch({ type: actionTypes.GET_DOT_LICENSE_BATCH_DETAIL_CERT, payload: data.data });
    } else {
      dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    }
    if (setLoading) setLoading(false);
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    if (setLoading) setLoading(false);
  }
};
